var render = function (_h,_vm) {
var _obj;
var _c=_vm._c;return _c('router-link',{class:Object.assign({}, _vm.data.class, ( _obj = {}, _obj[_vm.data.staticClass] = !!_vm.data.staticClass, _obj )),attrs:{"to":_vm.props.to || ""}},[_vm._t("default",[_vm._v(_vm._s(_vm.parent.$t(_vm.props.text || "Forward")))]),_vm._v(" → ")],2)}
var staticRenderFns = []

export { render, staticRenderFns }